import { connectRouter, routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()

const historyReducer = connectRouter(history)

export const historyMiddleware = routerMiddleware(history)

export default historyReducer